import { render, staticRenderFns } from "./ReceiptCard.vue?vue&type=template&id=1acc2f6e&scoped=true"
import script from "./ReceiptCard.vue?vue&type=script&lang=ts"
export * from "./ReceiptCard.vue?vue&type=script&lang=ts"
import style0 from "./ReceiptCard.vue?vue&type=style&index=0&id=1acc2f6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acc2f6e",
  null
  
)

export default component.exports